import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Empty } from 'antd';
import TreatmentCard from './TreatmentCard';

const CardView = ({ data, selectedRowKeys, setSelectedRowKeys, showSelectedOnly }) => {
    const { t } = useTranslation();

    const results = data?.results || [];

    const filteredResults = useMemo(
        () =>
            showSelectedOnly
                ? results.filter((item) => selectedRowKeys.includes(item.id))
                : results,
        [showSelectedOnly, results, selectedRowKeys]
    );

    const handleSelect = (id, checked) => {
        setSelectedRowKeys((prev) =>
            checked ? [...prev, id] : prev.filter((key) => key !== id)
        );
    };

    if (!results.length) {
        return (
            <div className="text-center py-8">
                <Empty
                    description={t('common|No results found')}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            </div>
        );
    }

    return (
        <div className="card-view-container">
            {/* Cards Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                {filteredResults.map((record) => (
                    <TreatmentCard
                        key={record.id}
                        record={record}
                        isSelected={selectedRowKeys.includes(record.id)}
                        onSelect={handleSelect}
                    />
                ))}
            </div>
        </div>
    );
};

export default CardView;